export default "__VITE_ASSET__hXV_XT09__"